var render = function render(){var _vm=this,_c=_vm._self._c;return _c('row',{staticClass:"bgs-list",attrs:{"gutter":16,"type":"flex","align":"top"}},_vm._l((_vm.bgs),function(bg){return _c('i-col',{key:bg.id,attrs:{"span":"24"}},[_c('bgs-item',{attrs:{"bg":bg},on:{"edit":function($event){return _vm.$emit('edit', bg)}}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }